/* Burns Music Library: shared homepage behaviour
   Upload as: assets/burns-ui.js
   - one preview player for every [data-bu-track] on the page
   - filter tabs, review picker, dry/wet plugin demo, reveal-on-scroll */
(function () {
  if (window.BurnsUI) return;

  /* ---------- Preview player ---------- */
  var audio = new Audio();
  audio.preload = 'none';
  var current = null;
  var ab = null; // active dry/wet demo, so the two never play over each other

  function setTrack(track, state) {
    track.classList.toggle('is-playing', state === 'playing');
    track.classList.toggle('is-loading', state === 'loading');
    var btn = track.querySelector('[data-bu-play]');
    if (btn) {
      var name = btn.getAttribute('data-name') || 'preview';
      btn.setAttribute('aria-pressed', state === 'playing' ? 'true' : 'false');
      btn.setAttribute('aria-label', (state === 'playing' ? 'Pause ' : 'Play ') + name);
    }
    if (state === 'idle') track.style.setProperty('--bu-p', 0);
  }

  function stopPreview() {
    if (!current) return;
    audio.pause();
    setTrack(current, 'idle');
    current = null;
  }

  var pendingSeek = null;
  audio.addEventListener('loadedmetadata', function () {
    if (pendingSeek != null && audio.duration) { audio.currentTime = pendingSeek * audio.duration; pendingSeek = null; }
  });
  function seekTrack(track, ratio) {
    if (current === track && audio.duration) {
      audio.currentTime = ratio * audio.duration;
      if (audio.paused) audio.play();
      return;
    }
    playTrack(track);
    pendingSeek = ratio;
  }

  function playTrack(track) {
    var src = track.getAttribute('data-src');
    if (!src) return;
    if (ab) ab.stop();
    if (current === track) {
      if (audio.paused) audio.play(); else audio.pause();
      return;
    }
    stopPreview();
    current = track;
    setTrack(track, 'loading');
    audio.src = src;
    var p = audio.play();
    if (p && p.catch) p.catch(function () { if (current === track) setTrack(track, 'idle'); });
  }

  audio.addEventListener('playing', function () { if (current) setTrack(current, 'playing'); });
  audio.addEventListener('pause', function () { if (current) setTrack(current, 'paused'); });
  audio.addEventListener('ended', function () { if (current) { setTrack(current, 'idle'); current = null; } });
  audio.addEventListener('error', function () { if (current) { setTrack(current, 'idle'); current = null; } });
  audio.addEventListener('timeupdate', function () {
    if (current && audio.duration) current.style.setProperty('--bu-p', (audio.currentTime / audio.duration).toFixed(4));
  });

  document.addEventListener('click', function (e) {
    var sk = e.target.closest('[data-bu-seek]');
    if (sk) {
      var tr = sk.closest('[data-bu-track]');
      if (tr) {
        var r = sk.getBoundingClientRect();
        seekTrack(tr, Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)));
      }
      return;
    }
    var btn = e.target.closest('[data-bu-play]');
    if (!btn) return;
    var track = btn.closest('[data-bu-track]');
    if (!track) return;
    e.preventDefault();
    playTrack(track);
  });

  /* ---------- Filter tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-bu-tab]');
    if (!tab) return;
    var group = tab.closest('[data-bu-tabs]');
    if (!group) return;
    var id = tab.getAttribute('data-bu-tab');
    group.querySelectorAll('[data-bu-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      t.tabIndex = t === tab ? 0 : -1;
    });
    group.querySelectorAll('[data-bu-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-bu-panel') !== id;
    });
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-bu-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[data-bu-tabs]').querySelectorAll('[data-bu-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    next.focus();
    next.click();
  });

  /* ---------- Review picker ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bu-review]');
    if (!b) return;
    var root = b.closest('[data-bu-reviews]');
    var i = b.getAttribute('data-bu-review');
    root.querySelectorAll('[data-bu-review]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    root.querySelectorAll('[data-bu-quote]').forEach(function (q) { q.hidden = q.getAttribute('data-bu-quote') !== i; });
  });

  /* ---------- Dry / wet plugin demo ---------- */
  function ABDemo(el) {
    var self = this;
    var dry = new Audio(el.getAttribute('data-dry'));
    var wet = new Audio(el.getAttribute('data-wet'));
    dry.preload = wet.preload = 'none';
    var mode = 'wet';
    var playing = false;
    function sync() {
      dry.muted = mode !== 'dry';
      wet.muted = mode !== 'wet';
      el.querySelectorAll('[data-bu-ab-mode]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-bu-ab-mode') === mode ? 'true' : 'false');
      });
    }
    function setPlaying(on) {
      playing = on;
      el.classList.toggle('is-playing', on);
      var btn = el.querySelector('[data-bu-ab-play]');
      if (btn) btn.setAttribute('aria-label', on ? 'Pause demo' : 'Play demo');
    }
    this.stop = function () { dry.pause(); wet.pause(); setPlaying(false); if (ab === self) ab = null; };
    el.querySelector('[data-bu-ab-play]').addEventListener('click', function () {
      if (playing) { self.stop(); return; }
      stopPreview();
      if (ab && ab !== self) ab.stop();
      ab = self;
      sync();
      wet.currentTime = dry.currentTime;
      Promise.all([dry.play(), wet.play()]).then(function () { setPlaying(true); }).catch(function () { setPlaying(false); });
    });
    el.querySelectorAll('[data-bu-ab-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-bu-ab-mode');
        if (playing && Math.abs(wet.currentTime - dry.currentTime) > 0.08) wet.currentTime = dry.currentTime;
        sync();
      });
    });
    dry.addEventListener('timeupdate', function () {
      if (dry.duration) el.style.setProperty('--bu-p', (dry.currentTime / dry.duration).toFixed(4));
    });
    dry.addEventListener('ended', function () { self.stop(); dry.currentTime = wet.currentTime = 0; });
    sync();
  }

  /* ---------- Diagnostic: ?calm=1 turns off all motion ---------- */
  if (/[?&]calm=1/.test(location.search)) document.documentElement.classList.add('bu-calm');

  /* ---------- Mark the page as scrolling (disables hover effects meanwhile) ---------- */
  var scrollT = null, html = document.documentElement;
  window.addEventListener('scroll', function () {
    if (!scrollT) html.classList.add('bu-scrolling');
    clearTimeout(scrollT);
    scrollT = setTimeout(function () { html.classList.remove('bu-scrolling'); scrollT = null; }, 140);
  }, { passive: true });

  /* ---------- Pause off-screen sections ---------- */
  var offIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target.classList.toggle('bu-off', !en.isIntersecting); });
  }, { rootMargin: '200px 0px' }) : null;

  function init(root) {
    root = root || document;
    var want = new URLSearchParams(window.location.search).get('tab');
    if (want) {
      want = want.toLowerCase();
      root.querySelectorAll('[data-bu-tab-key]').forEach(function (t) {
        if (t.getAttribute('aria-selected') !== 'true' && t.getAttribute('data-bu-tab-key').indexOf(want) === 0) t.click();
      });
    }
    if (offIO) (root.matches && root.matches('.bu') ? [root] : root.querySelectorAll('.bu')).forEach(function (el) { offIO.observe(el); });
    loadRecs(root);
    root.querySelectorAll('[data-bu-ab]').forEach(function (el) {
      if (el.__buab) return;
      el.__buab = new ABDemo(el);
    });
  }

  /* ---------- Add to cart without leaving the page (opens Spotlight's cart drawer) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-bu-cart]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // falls back to the cart page
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-bu-cart-error]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (err) err.hidden = true;
    var fd = new FormData(form);
    var sections = typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : [];
    fd.append('sections', sections.join(','));
    fd.append('sections_url', window.location.pathname);
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) {
        if (err) { err.textContent = res.description || res.message || 'Could not add to cart.'; err.hidden = false; }
        return;
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'burns' });
    }).catch(function () { form.removeAttribute('data-bu-cart'); form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });

  /* ---------- Shelves: arrow buttons scroll their row ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bu-shelf-prev], [data-bu-shelf-next]');
    if (!b) return;
    var shelf = b.closest('[data-bu-shelf]');
    var track = shelf && shelf.querySelector('[data-bu-shelf-track]');
    if (!track) return;
    var dir = b.hasAttribute('data-bu-shelf-next') ? 1 : -1;
    track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.85, 240), behavior: 'smooth' });
  });

  /* ---------- Collection sort: navigate on change ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-bu-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Load more (collection grids) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bu-more]');
    if (!btn) return;
    e.preventDefault();
    var grid = document.getElementById(btn.getAttribute('data-bu-more'));
    var url = btn.getAttribute('href');
    if (!grid || !url || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var label = btn.textContent;
    btn.textContent = 'Loading…';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.getElementById(grid.id);
      if (newGrid) Array.prototype.forEach.call(newGrid.children, function (c) { grid.appendChild(document.importNode(c, true)); });
      var next = doc.querySelector('[data-bu-more="' + grid.id + '"]');
      if (next) { btn.setAttribute('href', next.getAttribute('href')); btn.textContent = label; btn.classList.remove('is-loading'); }
      else { var w = btn.closest('[data-bu-more-wrap]'); if (w) w.remove(); else btn.remove(); }
    }).catch(function () { window.location.href = url; });
  });

  /* ---------- Product recommendations ("More like this") ---------- */
  function loadRecs(root) {
    (root || document).querySelectorAll('[data-bu-recs-url]').forEach(function (el) {
      if (el.__burecs) return;
      el.__burecs = true;
      var go = function () {
        fetch(el.getAttribute('data-bu-recs-url')).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var got = tmp.querySelector('[data-bu-recs-url]');
          if (got && got.innerHTML.trim()) { el.innerHTML = got.innerHTML; el.hidden = false; }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { o.disconnect(); go(); } }, { rootMargin: '400px 0px' });
        o.observe(el);
      } else go();
    });
  }

  /* ---------- Leaving the page pauses every player ----------
     Phones keep pages in memory for the back button; without this, a preview that was
     playing would start again when you swipe back. Covers every player on the site. */
  var everPlayed = [];
  var nativePlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    if (everPlayed.indexOf(this) === -1) everPlayed.push(this);
    return nativePlay.apply(this, arguments);
  };
  window.addEventListener('pagehide', function () {
    everPlayed.forEach(function (m) { try { if (!m.muted && !m.paused) m.pause(); } catch (e) {} });
    if (ab) ab.stop();
  });

  window.BurnsUI = { init: init, recs: loadRecs, stop: stopPreview, seek: seekTrack };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { stopPreview(); if (ab) ab.stop(); });
})();
